<template>
  <main>
    <v-container>
      <!-- Display Logo -->
      <v-row align="center" justify="center">
        <v-col class="px-5">
          <v-col cols="12">
            <v-img
              :src="require('../assets/BQLD Logo.png')"
              class="my-1"
              contain
              height="120"
              elevation="24"
            />
          </v-col>
        </v-col>
      </v-row>
    <div class="mb-5">
    <v-row>
      <!-- Display heading box -->
      <v-col cols="12">
          <!-- Two Cards so it displays the boarder around the text  -->
          <v-card 
            color="oug"
            class="pa-1 mx-auto text-center justify-center" 
            max-width="600" 
            elevation="20"
          >
            <v-card>
              <p class="text-h5">
                Welcome to the BQ Referees App!
              </p>
                <p>The new Referee app is live and ready to go! Click below to read whats new in the App</p>
                <v-btn outlined color="oug" class="mb-3" @click="latestNewsDialog = true">
                  Read More
                </v-btn>
            </v-card>
        </v-card>
      </v-col>
    </v-row>
    </div>
    <!-- Display Buttons in Middle of Home Screen -->
    <v-layout wrap align-end>
      <v-flex>
        <v-row justify="space-around">
          <v-col cols="4">
            <v-btn elevation="24" max-width="100px" color="oug" light outlined large to="Courses">Courses</v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn elevation="24" max-width="100px" color="oug" light outlined large to="Calendar">Events</v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn elevation="24" max-width="100px" color="oug" light outlined large to="Videos">Videos</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn elevation="24" color="oug" block light outlined large to="Pathway">Pathways</v-btn>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
    <!-- Dialogue Box that pops up when you select Read More in Main Box -->
    <v-dialog v-model="latestNewsDialog">
        <v-card>
          <v-card-title align="center">What's New in the BQ Referee App</v-card-title>
          <v-card-text>
            <h4>
            The BQ Referee App is now live and has some brand new features:
            </h4>
            <p></p>
            <ul align="start">
              <li>All resources that you require as a referee can be found inside this dedicated App</li>
              <li>Faster, more responsive design makes it easier to navigate around the app</li>
              <li>Have quick access to Courses, Videos, Documents and alike</li>
              <li>Keep track of your Accreditation and download Referee Certificates</li>
              <li>Discover Referee Accreditation Pathways and other non-formal opportunities</li>
              <li>Book into upcoming Courses and Clinics through the Calendar section</li>
            </ul>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="oug"
              outlined
              @click="latestNewsDialog = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </main>
</template>

<script>

export default {
  name: "Home",
  data: () => ({
    latestNewsDialog: false,
  }),
  methods: {},
};
</script>

<style scoped>
img{
  width: 30%
}

.checks {
  display: inline-flex;
}

</style>
